import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Factory, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch {
      toast.error("Falha ao solicitar recuperação");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B140F] text-white flex items-center justify-center p-6" data-testid="forgot-password-page">
      <div className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#234935]/40 blur-[120px]" />
        <div className="absolute top-1/3 -right-48 h-[480px] w-[480px] rounded-full bg-[#C5A059]/20 blur-[140px]" />
      </div>
      <div className="relative z-10 w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-[12px] text-white/60 hover:text-white mb-6" data-testid="fp-back-login">
          <ArrowLeft className="h-3.5 w-3.5" /> Voltar ao login
        </Link>
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="grid h-11 w-11 place-items-center rounded-lg bg-gradient-to-br from-[#234935] to-[#1A231F] ring-1 ring-[#C5A059]/30">
              <Factory className="h-5 w-5 text-[#C5A059]" />
            </div>
            <div>
              <div className="font-display text-[17px] font-semibold">Recuperar senha</div>
              <div className="text-[10.5px] uppercase tracking-[0.22em] text-white/60">TheoKratos RH</div>
            </div>
          </div>

          {sent ? (
            <div className="space-y-4" data-testid="fp-success">
              <div className="flex items-center gap-2 rounded-md border border-emerald-400/30 bg-emerald-400/10 p-4">
                <CheckCircle2 className="h-5 w-5 text-emerald-400 shrink-0" />
                <div className="text-[13px] text-white/85">
                  Se o email estiver cadastrado, um link de recuperação foi gerado.
                  Entre em contato com o administrador de RH para receber o link
                  (integração de email será adicionada em breve).
                </div>
              </div>
              <Button asChild className="w-full bg-[#C5A059] text-[#1A231F] hover:bg-[#D4B36B]">
                <Link to="/login">Voltar ao login</Link>
              </Button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <p className="text-[13px] text-white/70">
                Informe seu email corporativo para iniciar a recuperação de senha.
              </p>
              <div>
                <Label htmlFor="fp-email" className="text-[11px] uppercase tracking-wider text-white/70">Email</Label>
                <div className="relative mt-1">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-white/40" />
                  <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                         placeholder="seu.email@empresa.com"
                         className="pl-10 bg-white/[0.04] border-white/10 text-white placeholder:text-white/30 focus-visible:ring-[#C5A059]"
                         data-testid="fp-email-input" />
                </div>
              </div>
              <Button type="submit" disabled={loading || !email}
                      className="w-full bg-[#C5A059] text-[#1A231F] hover:bg-[#D4B36B] font-semibold"
                      data-testid="fp-submit-btn">
                {loading ? "Enviando..." : "Enviar solicitação"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
